import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './index.css'
import App from './App.tsx'
import { PowGate } from './components/forum/pow-gate.tsx'
import { AgeGate } from './components/forum/age-gate.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <PowGate>
        <AgeGate>
          <App />
        </AgeGate>
      </PowGate>
    </BrowserRouter>
  </StrictMode>,
)
